<label
  class="field__holder"
  [ngClass]="{ 'no-placeholder': !placeholder, disabled: disabled || isLoading, focus: dropdownOpen, show: dropdownOpen }"
  [loadingAnimation]="isLoading"
  ngbDropdown
  [autoClose]="'outside'"
  placement="bottom-left"
  #dropdown="ngbDropdown"
  (openChange)="onDropdownOpenChange($event)"
>
  @if (selectedOption?.icon) {
    <span [class]="'withIcon ' + selectedOption.icon" [style.color]="selectedOption.iconColor || 'inherit'"></span>
  }

  <input
    #searchInput
    type="text"
    [class]="fieldClassName"
    [name]="name"
    [value]="inputValue"
    [disabled]="disabled || isLoading"
    [required]="required"
    [readOnly]="disableSearch"
    (click)="onInputClick()"
    (focus)="onInputFocus()"
    (blur)="onInputBlur()"
    (keydown)="onInputKeydown($event)"
    (input)="onInputInput($event)"
    autocomplete="off"
    role="combobox"
    [attr.aria-expanded]="dropdownOpen"
    [attr.aria-autocomplete]="disableSearch ? 'none' : 'list'"
    autocorrect="off"
    spellcheck="false"
    autocapitalize="off"
    ngbDropdownAnchor
  />

  @if (shouldShowSelectionOverlay) {
    <div class="select__selection" [class.select__selection--with-icon]="selectedOption?.icon">
      <span class="select__selection-main" [class.select__selection-main--margin-override]="useSelectionMarginOverride">
        <span class="select__selection-text" [class]="selectedOption?.className || ''" [innerHTML]="selectedOption?.value"></span>
        @if (selectedOption?.flag || selectedOption?.credits) {
          <span class="select__inline-meta">
            @if (selectedOption?.flag) {
              <span class="monster__badge badge-XS" [ngClass]="getFlagBadgeClass(selectedOption?.flag)">{{ getFlagLabel(selectedOption?.flag) }}</span>
            }
            @if (selectedOption?.credits) {
              <span class="credits__content monster__badge badge-XS badge-success" [ngbTooltip]="infoCreditsTooltip" tooltipClass="select-tooltip" container="body">
                <i class="fa fa-shield-check"></i>
                {{ selectedOption?.credits }}
              </span>
            }
          </span>
        }
      </span>
    </div>
  }

  @if (placeholder) {
    <span class="field__placeholder">{{ placeholder }}</span>
  }

  <div class="field__separator"></div>

  <div ngbDropdownMenu class="select__menu" [style.max-height]="coerceCssSize(menuMaxHeight)" [class.invalid]="invalid">
    @for (option of filteredOptions; track trackByOptionIndex($index, option); let index = $index) {
      <button
        type="button"
        class="dropdown-item select__option"
        [class.hover]="index === activeIndex"
        [class.select__option--selected]="isOptionSelected(option)"
        [ngbTooltip]="option.tooltip"
        tooltipClass="select-tooltip"
        container="body"
        [placement]="option.tooltipPlacement || 'right'"
        [style.height.px]="option.height"
        (mouseenter)="setActiveIndex(index)"
        (mousedown)="onOptionMouseDown($event, option)"
      >
        <span class="select__option-main">
          @if (option?.icon) {
            <span [class]="'option__icon ' + option.icon" [style.color]="option.iconColor || 'inherit'"></span>
          }
          <span class="select__option-content">
            <span class="select__option-text" [class]="option.className || ''" [style.font-size.px]="option.fontSize" [style.max-width.px]="option.limitWidth" [innerHTML]="option.value"></span>
            @if (option.flag || option.credits) {
              <span class="select__inline-meta">
                @if (option.flag) {
                  <span class="monster__badge badge-XS" [ngClass]="getFlagBadgeClass(option.flag)">{{ getFlagLabel(option.flag) }}</span>
                }
                @if (option.credits) {
                  <span class="credits__content monster__badge badge-XS badge-success" [ngbTooltip]="infoCreditsTooltip" tooltipClass="select-tooltip" container="body">
                    <i class="fa fa-shield-check"></i>
                    {{ option.credits }}
                  </span>
                }
              </span>
            }
          </span>
        </span>
      </button>
    }
  </div>
</label>

<ng-template #infoCreditsTooltip>
  <div class="tooltip__title">{{ 'shared.additionalValidationCredit' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'shared.additionalValidationExplanation' | translate }}
  </div>
</ng-template>
